export default "__VITE_ASSET__C2LgEb3x__"